<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "digitalCards.variables" | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body dc-palette-dialog-content">
    <app-variable-palette
      [targetEditor]="targetEditor"
      [isExternalExpanded]="true"
    ></app-variable-palette>
  </div>

  <footer class="app-dialog__footer">
    <button mat-button type="button" (click)="close()">{{ "close" | translate }}</button>
  </footer>
</div>
